import { SearchOutlined } from '@ant-design/icons';
import { Button, Row, Col } from 'antd';
import moment from 'moment';
import { getDetailMachine } from 'pages/ListMachine/thunk';
import { FC } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { RootState } from 'store';
import { HeaderTitle, BackToPrevMachine, Rectangle } from 'components';
import Wrap from './styles';

const DetailAfterEndLease: FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation<{ itemId: string }>();
  const { itemDetail } = useSelector((state: RootState) => state.machine);

  useEffect(() => {
    dispatch(getDetailMachine(location.state.itemId));
  }, [dispatch, location.state.itemId]);

  const ListMachine = () => {
    history.push('/machine');
  };
  return (
    <Wrap>
      <HeaderTitle title="リース契約詳細" icon={SearchOutlined} />
      <BackToPrevMachine backToPrev={ListMachine} />
      <div className="termination-of-lease">
        <Button className="btn-termination-of-lease standardBoldFont">リース契約終了</Button>
      </div>
      <div className="section">
        <div className="delete-lease">
          <Rectangle text="リース情報" decor="bd" />
          <div className="info-delete-lease">
            <Row className="pb-16 bd">
              <Col className="standardBoldFont pl-5" span={5}>
                リース期間
              </Col>
              <Col className="standardFont" span={19}>
                {itemDetail?.lease_start_date && moment(itemDetail.lease_start_date).format('YYYY年MM月DD日')}〜
                {itemDetail?.lease_end_date && moment(itemDetail.lease_end_date).format('YYYY年MM月DD日')}
              </Col>
            </Row>
            <Row className="pb-16 pt-16 bd">
              <Col className="standardBoldFont pl-5" span={5}>
                契約日
              </Col>
              <Col className="standardFont" span={19}>
                {itemDetail?.lease_contract_date && moment(itemDetail.lease_contract_date).format('YYYY年MM月DD日')}
              </Col>
            </Row>
            <Row className="pb-16 pt-16 bd">
              <Col className="standardBoldFont pl-5" span={5}>
                台数
              </Col>
              <Col className="standardFont" span={19}>
                -台
              </Col>
            </Row>
            <Row className="pb-16 pt-16 bd">
              <Col className="standardBoldFont pl-5" span={5}>
                リース会社
              </Col>
              <Col className="standardFont" span={19}>
                大丸エナウィン
              </Col>
            </Row>
            <Row className="pb-16 pt-16 bd">
              <Col className="standardBoldFont pl-5" span={5}>
                販売店
              </Col>
              <Col className="standardFont" span={19}>
                {itemDetail?.lease_shop}
                {itemDetail?.lease_shop_other}
              </Col>
            </Row>
            <Row className="pt-16">
              <Col className="standardBoldFont pl-5" span={5}>
                契約番号
              </Col>
              <Col className="standardFont" span={19}>
                {itemDetail?.lease_contract_id}
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Wrap>
  );
};
export default DetailAfterEndLease;
